import { checkIfExist } from "../../../services/GraphService";
import { IItemCheck } from "./IItemCheck";


export class TeamSiteCheck implements IItemCheck {
    doesItemExist = async (itemId: string) => {
        const url = `teams/${itemId}`;
        return await checkIfExist(url, "id");
    };
}
